export default "__VITE_ASSET__C7_oP7Ny__"